<template>
  <div class="flex flex-col border border-t border-b border-r-0 border-l-0">
    <div class="flex min-h-full">
      <div class="flex flex-col w-full">
        <div class="flex flex-row w-full">
          <div class="flex flex-col gap-6 w-[70%] border-r p-3">
            <div class="w-[155px] h-4 rounded bg-zinc-200 animate-pulse" />
            <div class="w-[102px] h-4 rounded bg-zinc-200 animate-pulse" />
            <div class="w-[155px] h-4 rounded bg-zinc-200 animate-pulse" />
            <div class="w-[102px] h-4 rounded bg-zinc-200 animate-pulse" />
            <div class="w-[102px] h-4 rounded bg-zinc-200 animate-pulse" />
          </div>
          <div class="flex gap-10 w-[30%] p-3">
            <div class="flex flex-col gap-6">
              <div class="w-[155px] h-4 rounded bg-zinc-200 animate-pulse" />
              <div class="w-[102px] h-4 rounded bg-zinc-200 animate-pulse" />
              <div class="w-[155px] h-4 rounded bg-zinc-200 animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
